<template>
	<el-dropdown size="small" type="primary" :hide-on-click="false" placement="left" @command="handleCommand">
        <el-button type="primary" icon="el-icon-more" circle size="mini"></el-button>
        <el-dropdown-menu class="dropdown-text-center" slot="dropdown" v-if="$slots.default">
            <slot v-if="$slots.default"></slot>
        </el-dropdown-menu>
        <el-dropdown-menu slot="dropdown" v-else>
            <el-dropdown-item class="dropdown-text-center" :command="option.evt" :disabled="!!option.disabled" :divided="index!=0" v-for="(option,index) in data" :key="option.key">{{option.title}}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
	import Vue, { Component } from 'C/BaseVue'
	import mixin, { userMess } from 'M/mixin'

	@Component({
		props: ['data','extraParams'],
		mixins: [mixin, userMess]
	})

	export default class TableOperationTabs extends Vue {
        mounted(){}
        handleCommand(command){
            command(this.extraParams)
        }
	}

</script>
<style lang="scss" scoped>
.dropdown-text-center{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TableOperationTabs.vue